import getDurationRow from '@/utils/time/datetime';
import getLocalTime from '@/utils/time/localtime';
import getDurationUtc from '@/utils/time/utctime';
import getTimeZoneOff from '@/utils/time/timezone';
import { Duration, DurationTime } from '@/utils/types/global';
import { State } from '@/store/modules/global/settings/settings.store';
import { TimeUnits } from '@/utils/enums/timeUnits';
import router from '@/router';
import { TRACE } from '@/store/modules/global/settings/settings.config';
import { TenantInfo } from '@/store/modules/global/settings/settings.interfaces';
const dateFormatTime = (date: Date, step: string): string => {
  const year = date.getFullYear();
  const monthTemp = date.getMonth() + 1;
  let month: string = `${monthTemp}`;
  if (monthTemp < 10) {
    month = `0${monthTemp}`;
  }
  if (step === TimeUnits.MONTH) {
    return `${year}-${month}`;
  }
  const dayTemp = date.getDate();
  let day: string = `${dayTemp}`;
  if (dayTemp < 10) {
    day = `0${dayTemp}`;
  }
  if (step === TimeUnits.DAY) {
    return `${month}-${day}`;
  }
  const hourTemp = date.getHours();
  let hour: string = `${hourTemp}`;
  if (hourTemp < 10) {
    hour = `0${hourTemp}`;
  }
  if (step === TimeUnits.HOUR) {
    return `${month}-${day} ${hour}`;
  }
  const minuteTemp = date.getMinutes();
  let minute: string = `${minuteTemp}`;
  if (minuteTemp < 10) {
    minute = `0${minuteTemp}`;
  }
  if (step === TimeUnits.MINUTE) {
    return `${hour}:${minute}\n${month}-${day}`;
  }
  return '';
};

export const dateFormat = (date: Date, step: string): string => {
  const year = date.getFullYear();
  const monthTemp = date.getMonth() + 1;
  let month: string = `${monthTemp}`;
  if (monthTemp < 10) {
    month = `0${monthTemp}`;
  }
  if (step === TimeUnits.MONTH) {
    return `${year}-${month}`;
  }
  const dayTemp = date.getDate();
  let day: string = `${dayTemp}`;
  if (dayTemp < 10) {
    day = `0${dayTemp}`;
  }
  if (step === TimeUnits.DAY) {
    return `${year}-${month}-${day}`;
  }
  const hourTemp = date.getHours();
  let hour: string = `${hourTemp}`;
  if (hourTemp < 10) {
    hour = `0${hourTemp}`;
  }
  if (step === TimeUnits.HOUR) {
    return `${year}-${month}-${day} ${hour}`;
  }
  const minuteTemp = date.getMinutes();
  let minute: string = `${minuteTemp}`;
  if (minuteTemp < 10) {
    minute = `0${minuteTemp}`;
  }
  if (step === TimeUnits.MINUTE) {
    return `${year}-${month}-${day} ${hour}${minute}`;
  }
  return '';
};

const getters = {
  duration(state: State): Duration {
    return {
      start: getLocalTime(parseFloat(state.utc), state.durationRow.start),
      end: getLocalTime(parseFloat(state.utc), state.durationRow.end),
      step: state.durationRow.step,
    };
  },
  licenseDuration(state: State): Duration {
    return {
      start: getLocalTime(
        parseFloat(state.utc),
        state.durationLicenseRow.start,
      ),
      end: getLocalTime(parseFloat(state.utc), state.durationLicenseRow.end),
      step: state.durationLicenseRow.step,
    };
  },
  durationShow(state: State): Duration {
    return {
      start: getLocalTime(state.timezoneoffset, state.durationRow.start),
      end: getLocalTime(state.timezoneoffset, state.durationRow.end),
      step: state.durationRow.step,
    };
  },
  licenseDurationShow(state: State): Duration {
    return {
      start: getLocalTime(state.timezoneoffset, state.durationLicenseRow.start),
      end: getLocalTime(state.timezoneoffset, state.durationLicenseRow.end),
      step: state.durationLicenseRow.step,
    };
  },
  intervalTime(state: State, getter: any): string[] {
    let interval: number = 946080000000;
    switch (getter.durationShow.step) {
      case 'MINUTE':
        interval = 60000;
        break;
      case 'HOUR':
        interval = 3600000;
        break;
      case 'DAY':
        interval = 86400000;
        break;
      case 'MONTH':
        interval =
          (getter.durationShow.end.getTime() -
            getter.durationShow.start.getTime()) /
          (getter.durationShow.end.getFullYear() * 12 +
            getter.durationShow.end.getMonth() -
            getter.durationShow.start.getFullYear() * 12 -
            getter.durationShow.start.getMonth());
        break;
    }
    //const utcSpace = (parseInt(state.utc + '', 10) + new Date().getTimezoneOffset() / 60) * 3600000;
    const startUnix: number = getter.durationShow.start.getTime();
    const endUnix: number = getter.durationShow.end.getTime();
    const timeIntervals: string[] = [];
    for (let i = 0; i <= endUnix - startUnix; i += interval) {
      //const temp: string = dateFormatTime(new Date(startUnix + i - utcSpace), getter.duration.step);
      const temp: string = dateFormatTime(
        new Date(startUnix + i),
        getter.durationShow.step,
      );
      timeIntervals.push(temp);
    }
    return timeIntervals;
  },
  licenseIntervalTime(state: State, getter: any): string[] {
    let interval: number = 946080000000;
    switch (getter.licenseDurationShow.step) {
      case 'MINUTE':
        interval = 60000;
        break;
      case 'HOUR':
        interval = 3600000;
        break;
      case 'DAY':
        interval = 86400000;
        break;
      case 'MONTH':
        interval =
          (getter.licenseDurationShow.end.getTime() -
            getter.licenseDurationShow.start.getTime()) /
          (getter.licenseDurationShow.end.getFullYear() * 12 +
            getter.licenseDurationShow.end.getMonth() -
            getter.licenseDurationShow.start.getFullYear() * 12 -
            getter.licenseDurationShow.start.getMonth());
        break;
    }
    //const utcSpace = (parseInt(state.utc + '', 10) + new Date().getTimezoneOffset() / 60) * 3600000;
    const startUnix: number = getter.licenseDurationShow.start.getTime();
    const endUnix: number = getter.licenseDurationShow.end.getTime();
    const timeIntervals: string[] = [];
    for (let i = 0; i <= endUnix - startUnix; i += interval) {
      //const temp: string = dateFormatTime(new Date(startUnix + i - utcSpace), getter.duration.step);
      const temp: string = dateFormatTime(
        new Date(startUnix + i),
        getter.licenseDurationShow.step,
      );
      timeIntervals.push(temp);
    }
    return timeIntervals;
  },
  getDurationTime(_: State, getter: any): DurationTime {
    const step =
      router.currentRoute.value.name === TRACE
        ? TimeUnits.MINUTE
        : getter.duration.step;
    return {
      start: dateFormat(getter.duration.start, step),
      end: dateFormat(getter.duration.end, step),
      step,
    };
  },
  getForecastDurationTime(_: State, getter: any): DurationTime {
    return {
      start: dateFormat(getter.duration.start, getter.duration.step),
      end: dateFormat(
        new Date(getter.duration.end.getTime() + 6 * 60 * 60 * 1000),
        getter.duration.step,
      ),
      step: getter.duration.step,
    };
  },
  getLicenseDurationTime(_: State, getter: any): DurationTime {
    return {
      start: dateFormat(
        getter.licenseDuration.start,
        getter.licenseDuration.step,
      ),
      end: dateFormat(getter.licenseDuration.end, getter.licenseDuration.step),
      step: getter.licenseDuration.step,
    };
  },
  getTimezone(state: State, getter: any) {
    return state.timezone;
  },
  getAllTimezones(state: State, getter: any) {
    state.timeZones.sort(compare);
    return state.timeZones;
  },
  getTimeZoneOff(state: State, getter: any) {
    return state.timezoneoffset;
  },
  getCurrTimeLabel(state: State) {
    return state.currTimeLabel;
  },
  getUTC(state: State) {
    return state.utc;
  },
  getTransaction(state: State) {
    return state.transcation;
  },
  getTransDispAppl(state: State) {
    return (
      state.transcation.applicationTableList?.length > 0 &&
      state.transcation.endpointTableList?.length === 0
    );
  },
  getTransDispEndpoint(state: State) {
    return state.transcation.endpointTableList?.length > 0;
  },
  getTransDispEpExclude(state: State) {
    return state.transcation.epExcludeTableList?.length > 0;
  },
  getQueryTableData(state: State) {
    return state.queryTableData;
  },
  getWidgetAddDashboardInfo(state: State) {
    return state.addWidgetData.addDashboardInfo;
  },
  getWidgetFormData(state: State) {
    return state.addWidgetData.widgetFormData;
  },
  getQueryFormInfoFields(state: State) {
    return state.addWidgetData.queryFormInfo;
  },
  getActiveTimeLabel(state: State) {
    return state.activeTimeLabel;
  },
  getIsCompareOptionsSelected(state: State) {
    return state.isCompareOptionsSelected;
  },
  compareDurationShow(state: State): Duration {
    return {
      start: getLocalTime(state.timezoneoffset, state.compareDurationRow.start),
      end: getLocalTime(state.timezoneoffset, state.compareDurationRow.end),
      step: state.durationRow.step,
    };
  },
  getCompareDurationRow(state: State): Duration {
    return state.compareDurationRow;
  },
  compareDuration: (state: State): Duration => {
    return {
      start: getLocalTime(
        parseFloat(state.utc),
        state.compareDurationRow.start,
      ),
      end: getLocalTime(parseFloat(state.utc), state.compareDurationRow.end),
      step: state.compareDurationRow.step,
    };
  },
  getCompareDurationTime: (state: State, getters: any): DurationTime => {
    const compareDuration = getters.compareDuration;
    return {
      start: dateFormat(compareDuration.start, compareDuration.step),
      end: dateFormat(compareDuration.end, compareDuration.step),
      step: compareDuration.step,
    };
  },
  compareIntervalTime(state: State, getter: any): string[] {
    let interval: number = 946080000000;
    switch (getter.compareDurationShow.step) {
      case 'MINUTE':
        interval = 60000;
        break;
      case 'HOUR':
        interval = 3600000;
        break;
      case 'DAY':
        interval = 86400000;
        break;
      case 'MONTH':
        interval =
          (getter.compareDurationShow.end.getTime() -
            getter.compareDurationShow.start.getTime()) /
          (getter.compareDurationShow.end.getFullYear() * 12 +
            getter.compareDurationShow.end.getMonth() -
            getter.compareDurationShow.start.getFullYear() * 12 -
            getter.compareDurationShow.start.getMonth());
        break;
    }
    const startUnix: number = getter.compareDurationShow.start.getTime();
    const endUnix: number = getter.compareDurationShow.end.getTime();
    const timeIntervals: string[] = [];
    for (let i = 0; i <= endUnix - startUnix; i += interval) {
      const temp: string = dateFormatTime(
        new Date(startUnix + i),
        getter.compareDurationShow.step,
      );
      timeIntervals.push(temp);
    }
    return timeIntervals;
  },
  getCapabilityList(state: State) {
    return state.capPermInfo.map((obj) => ({
      label: obj.capability.label,
      value: obj.capability.value,
      isCustomisable: obj.capability.isCustomisable,
      capKey: obj.capability.capKey,
      types: obj.capability.types,
    }));
  },
  getRoleFormData(state: State) {
    return state.roleFormData;
  },
  getRoleFormName(state: State) {
    return state.roleFormData.roleName;
  },
  getSelectedCapabilities(state: State) {
    return state.roleFormData.resourceGroups.map((obj) => obj.resourceGroup);
  },
  getSelectedCapabilityDetails(state: State) {
    return state.roleFormData.resourceGroups;
  },
  getCapabilityPermMapper(state: State) {
    let mapper = {};
    let capPermInfo = state.capPermInfo;
    for (let i = 0; i < capPermInfo.length; i++) {
      mapper[capPermInfo[i].capability.value] = capPermInfo[i].permissions;
    }

    return mapper;
  },
  getCustomPermData(state: State) {
    return state.customPermData;
  },
  getCustomPermResourcesMapper(state: State) {
    const mapper = {};
    const resources = state.customPermData.resources;
    for (let i = 0; i < resources.length; i++) {
      if (resources[i]?.permissions?.length > 0)
        mapper[resources[i].resource] = resources[i].permissions;
    }
    return mapper;
  },
  getCustomResourcesMapper(state: State) {
    const mapper = {};
    const resources = state.customPermData.resources;
    for (let i = 0; i < resources.length; i++) {
      mapper[resources[i].resource] = resources[i];
    }
    return mapper;
  },
  getGroupRoleFormData(state: State) {
    return state.groupRoleFormData;
  },
  getRoleTenant(state: State) {
    return state.roleTenant;
  },
  getUserFormData(state: State) {
    return state.userFormData;
  },
  getRolesAndGroupRolesFieldData(state: State) {
    return state.rolesAndGroupRolesFieldData;
  },
  getTeamRolesMapData(state: State) {
    const groupRoles = state.rolesAndGroupRolesFieldData.groupRoles;
    let map = {};
    groupRoles.forEach((obj) => {
      obj.tenantRoles.forEach((tenantObj) => {
        let key = `${tenantObj.label}*${tenantObj.key}`;
        if (!map[key]) {
          map[key] = [];
        }
        map[key].push(...tenantObj.roles.map((roleObj) => roleObj));
      });
    });

    const tenantInfo: TenantInfo[] = [];
    for (let key of Object.keys(map)) {
      tenantInfo.push({
        tenantName: key.split('*')[0],
        roles: map[key],
      });
    }

    return tenantInfo;
  },
  getPermObjInfoMapper(state: State) {
    const permsMap = {};
    state.capPermInfo.forEach((obj) => {
      permsMap[obj.capability.value] = {
        isCustomisable: obj.capability.isCustomisable,
        capKey: obj.capability.capKey,
        types: obj.capability.types,
      };
    });
    return permsMap;
  },
  getReloadTable(state: State) {
    return state.reloadTable;
  },
  getCustomRange(state: State) {
    return state.customRange;
  },
  getIsCompareCustom(state: State) {
    return state.isCompareCustom;
  },
};
//for sorting timezones
function compare(a: any, b: any) {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
}
export default getters;
